/**
 * Hell-/Dunkelmodus. Gespeichert pro Gerät; "auto" folgt dem System.
 * Das erste Setzen passiert per Inline-Skript im <head> (kein Aufblitzen).
 */
const KEY = 'nn-theme';
const media = window.matchMedia('(prefers-color-scheme: dark)');

export const theme = {
    get() {
        try {
            return localStorage.getItem(KEY) || 'auto';
        } catch (e) {
            return 'auto';
        }
    },

    set(value) {
        try {
            localStorage.setItem(KEY, value);
        } catch (e) {
            // privater Modus o. Ä. – dann gilt die Wahl nur bis zum Neuladen
        }
        this.apply(value);
    },

    apply(value = this.get()) {
        const dark = value === 'dark' || (value === 'auto' && media.matches);
        document.documentElement.setAttribute('data-bs-theme', dark ? 'dark' : 'light');
    },
};

media.addEventListener('change', () => theme.get() === 'auto' && theme.apply());
